export default __webpack_public_path__ + "static/media/boletoIcon.8db47226.svg";